import type { QuestionDefinition } from "@reno-estimator/core";
import { booleanQuestion, builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion, windowsDoorsQuestion } from "./interior-room-shared.js";

/** Living Room (Phase 13A) - see rules/living-room.ts for the matching calculator. */
export const livingRoomQuestions: QuestionDefinition[] = [
  flooringQuestion("living_room", 200, "living room"),
  paintingQuestion("living_room", 210),
  trimQuestion("living_room", 220),
  lightingQuestion("living_room", 230),
  builtInsQuestion("living_room", 240, "What about built-in shelving or entertainment cabinetry?", "Custom built-in cabinetry"),
  windowsDoorsQuestion("living_room", 250, "Any window or door changes?"),
  booleanQuestion("living_room_fireplace", "living_room", "Adding or upgrading a fireplace?", 260)
];
